const ERROR_CATEGORY_MASK_NETWORK = 1 << 16;
const ERROR_CATEGORY_MASK_SERVER = 1 << 17;
const ERROR_CATEGORY_MASK_THIRDPARTY = 1 << 18;
const ERROR_CATEGORY_MASK_VALIDATION = 1 << 19;
const ERROR_CATEGORY_MASK_INTERNAL = 1 << 20;
const ERROR_CATEGORY_MASK_SECURITY = 1 << 21;
const ERROR_CATEGORY_MASK_PLAYBACK = 1 << 22;
const ERROR_CATEGORY_MASK_DOWNLOAD = 1 << 23;
const ERROR_CATEGORY_MASK_ANALYTICS = 1 << 24;

export const ErrorCodes = Object.freeze({
  ERROR_CATEGORY_MASK_ALL: 0xffff << 16,
  /**
   * Indicates that the error reason is Pure Network Failure like
   * Socket Timeout , Read Timeout etc.,
   */
  ERROR_CATEGORY_MASK_NETWORK,

  /**
   * Indicates that the Server has returned a failure Response
   */
  ERROR_CATEGORY_MASK_SERVER,

  /**
   * Indicates that the error is due to a Third-Party component/system failure
   * such as an External Player, Third-Party Library etc.,
   */
  ERROR_CATEGORY_MASK_THIRDPARTY,

  /**
   * Indicates that the error is due to a validation failure.
   * __This might not be applicable for Client Libraries__
   */
  ERROR_CATEGORY_MASK_VALIDATION,

  /**
   * Indicates that the error is due to an internal component.
   * Eg., Internal Server Error etc.,
   * __This might not be applicable for Client Libraries__
   */
  ERROR_CATEGORY_MASK_INTERNAL,

  /**
   * Indicates a Security related error
   * __This might not be applicable for Client Libraries__
   */
  ERROR_CATEGORY_MASK_SECURITY,

  /**
   * Indicates that the Error is relates to Content Playback
   */
  ERROR_CATEGORY_MASK_PLAYBACK,

  /**
   * Indicates that the Error is related to Content Download
   */
  ERROR_CATEGORY_MASK_DOWNLOAD,

  /**
   * Indicates that the Error is related to Analytics
   */
  ERROR_CATEGORY_MASK_ANALYTICS,
});
